// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__wyFyE","desktopHead":"Toolbar_desktopHead__lj7xt","mobileHead":"Toolbar_mobileHead__Cu4dI","DesktopOnly":"Toolbar_DesktopOnly__QdikG"};